module.exports = __webpack_public_path__ + "common/icon-facebook-d2b21c2756e6c92b9cfee48f44923cc3.svg";